import React, { useEffect, useState } from "react";
import { closeModal, formatDateTimeUtc, LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import {
  esslDeviceAdd,
  esslDeviceDelete,
  esslDeviceList,
  esslDeviceStatusChange,
  esslDeviceUpdate,
} from "../../../api/EsslDevice";
import usePrivateLink from "../../config/usePrivateLink";
import Swal from "sweetalert2";
import { formatToDateTime } from "../../master/FormatToDateTime";

export default function DevicesList() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState({});

  const getDevices = async () => {
    try {
      setLoading(true);

      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const response = await esslDeviceList(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const formData = new FormData(e.target);
      let response;
      if (modalData?.id) {
        response = await esslDeviceUpdate(formData);
      } else {
        response = await esslDeviceAdd(formData);
      }
      if (response.data.status) {
        closeModal("ModalFrom");
        setModalData({});
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
      getDevices();
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This batch will be permanently deleted. You cannot undo this action.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const response = await esslDeviceDelete(id);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
      getDevices();
    }
  };

  const handleStatusChange = async (id) => {
    setLoading(true);
    try {
      const response = await esslDeviceStatusChange(id);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
      getDevices();
    }
  };

  useEffect(() => {
    getDevices();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <h4 className="mb-0">ESSL Devices</h4>
                          </div>
                          <div className="col-6 text-end">
                            {hasAccess("/essl/device/add") && (
                              <button
                                onClick={() =>
                                  setModalData({
                                    device_id: "",
                                    serial_number: "",
                                    device_location: "",
                                  })
                                }
                                className="btn btn-outline-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#ModalFrom"
                              >
                                <i className="ri-add-circle-line me-2"></i>
                                Add New Device
                              </button>
                            )}
                          </div>
                          <div className="col-12">
                            <hr />
                          </div>
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                value={filters?.search}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    search: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="">Search</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Device ID</th>
                                <th>Serial Number</th>
                                <th>Location</th>
                                <th>Device Status</th>
                                <th>Last Ping</th>
                                <th>Status</th>
                                <th width="220">Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.map((item, index) => (
                                <tr key={item?.id}>
                                  <td>{index + 1}</td>

                                  <td>{item?.device_id}</td>

                                  <td>{item?.serial_number}</td>

                                  <td>{item?.device_location}</td>

                                  <td>
                                    <span
                                      className={` badge ${item?.device_status?.data?.DeviceStatus === "Online"
                                        ? "bg-success"
                                        : "bg-danger"
                                        }`}
                                    >
                                      <b> {item?.device_status?.data?.DeviceStatus ?? "Unknown"}</b>
                                    </span>
                                  </td>

                                  <td>
                                    {item?.device_status?.data?.LastPing ? (
                                      <>
                                        {formatDateTimeUtc(item.device_status.data.LastPing)}
                                        <br />
                                        {/* <small className="text-muted">
                                          Last seen {item.device_status.data.DiffMinutes} min ago
                                        </small> */}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={Number(item?.status) === 1}
                                        id={item?.id}
                                        onChange={() =>
                                          handleStatusChange(item?.id)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={item?.id}
                                      >
                                        {item?.status === "1"
                                          ? "Active"
                                          : "Inactive"}
                                      </label>
                                    </div>
                                  </td>

                                  <td>
                                    {hasAccess("/essl/devices/update") && (
                                      <button
                                        className="btn btn-sm btn-primary me-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#ModalFrom"
                                        onClick={() => setModalData(item)}
                                      >
                                        <i className="ri-ball-pen-line"></i>
                                      </button>
                                    )}

                                    {hasAccess("/essl/devices/delete") && (
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(item?.id)}
                                      >
                                        <i className="ri-delete-bin-line"></i>
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="ModalFrom"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Device {modalData?.id ? "Update" : "Add"}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {modalData?.id && (
                  <input
                    type="hidden"
                    name="id"
                    id="id"
                    value={modalData?.id}
                  />
                )}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Device ID"
                    name="device_id"
                    value={modalData?.device_id || ""}
                    onChange={(e) =>
                      setModalData({ ...modalData, device_id: e.target.value })
                    }
                    required
                  />
                  <label>Device ID</label>
                </div>

                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Serial Number"
                    name="serial_number"
                    value={modalData?.serial_number || ""}
                    onChange={(e) =>
                      setModalData({
                        ...modalData,
                        serial_number: e.target.value,
                      })
                    }
                    required
                  />
                  <label>Serial Number</label>
                </div>

                <div className="form-floating form-floating-outline mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Device Location"
                    name="device_location"
                    value={modalData?.device_location || ""}
                    onChange={(e) =>
                      setModalData({
                        ...modalData,
                        device_location: e.target.value,
                      })
                    }
                    required
                  />
                  <label>Device Location</label>
                </div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
